import { useState } from 'react'

export default function PromptInput({ value, onChange, onSubmit, loading }) {
  const [localValue, setLocalValue] = useState(value || '')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (localValue.trim() && !loading) {
      onSubmit(localValue)
      setLocalValue('')
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(e)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="w-100">
      <div className="form-control">
        <div className="input-group">
          <textarea
            className="textarea textarea-bordered flex-1"
            placeholder="Ask a research question..."
            value={localValue}
            onChange={(e) => {
              setLocalValue(e.target.value)
              onChange(e.target.value)
            }}
            onKeyDown={handleKeyDown}
            rows={3}
            disabled={loading}
            style={{ resize: 'none' }}
          />
          <button 
            type="submit" 
            className={`btn btn-primary btn-square h-auto ${loading ? 'loading' : ''}`}
            disabled={loading || !localValue.trim()}
          >
            {loading ? (
              <span className="loading loading-spinner"></span>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
              </svg>
            )}
          </button>
        </div>
        <label className="label">
          <span className="label-text-alt">Press Enter to send, Shift+Enter for new line</span>
        </label>
      </div>
    </form>
  )
}